import { motion } from "framer-motion";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="border-b border-[#E5E5E5] bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 flex flex-col justify-center">
            <motion.span
              variants={fade}
              initial="hidden"
              animate="show"
              custom={0}
              className="font-mono-nw text-xs tracking-[0.25em] uppercase text-[#002DFF] mb-6"
            >
              Business Process Outsourcing
            </motion.span>

            <motion.h1
              variants={fade}
              initial="hidden"
              animate="show"
              custom={1}
              className="font-display font-black uppercase tracking-tighter leading-[0.92] text-4xl sm:text-5xl lg:text-6xl"
            >
              Outsourced teams
              <br />
              that run your{" "}
              <span className="text-[#002DFF]">business</span>
            </motion.h1>

            <motion.p
              variants={fade}
              initial="hidden"
              animate="show"
              custom={2}
              className="mt-5 font-display font-bold uppercase tracking-tight text-lg sm:text-xl text-[#0A0A0A]"
            >
              Built to scale. Managed to perform.
            </motion.p>

            <motion.p
              variants={fade}
              initial="hidden"
              animate="show"
              custom={2}
              className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-[#525252]"
            >
              Live chat, virtual assistants, customer service, lead generation and
              admin support — delivered by elite, fully-managed teams so you can
              scale without the overhead.
            </motion.p>

            <motion.div
              variants={fade}
              initial="hidden"
              animate="show"
              custom={3}
              className="mt-10 flex flex-col sm:flex-row gap-4"
            >
              <a
                href="#contact"
                data-testid="hero-primary-cta"
                className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.15em] border border-[#0A0A0A] hover:bg-[#002DFF] hover:border-[#002DFF] transition-colors"
              >
                Scale Your Operations <ArrowUpRight className="w-4 h-4" />
              </a>
              <a
                href="#services"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center justify-center gap-2 bg-transparent text-[#0A0A0A] px-7 py-4 text-xs font-bold uppercase tracking-[0.15em] border border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors"
              >
                Explore Services <ArrowDownRight className="w-4 h-4" />
              </a>
            </motion.div>
          </div>

          <motion.div
            variants={fade}
            initial="hidden"
            animate="show"
            custom={2}
            className="lg:col-span-5 relative"
          >
            <div className="relative h-72 sm:h-96 lg:h-full min-h-[320px] border border-[#0A0A0A] overflow-hidden">
              <img
                src="https://images.pexels.com/photos/7682356/pexels-photo-7682356.jpeg"
                alt="NovaWorks customer support agents at work"
                className="w-full h-full object-cover grayscale"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-[#0A0A0A] text-white px-5 py-4 flex items-center justify-between">
                <span className="font-mono-nw text-[10px] tracking-[0.2em] uppercase">
                  Knoxville · Davao · General Santos
                </span>
                <span className="w-2 h-2 bg-[#002DFF]" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
